import { render, staticRenderFns } from "./AfterScreening.vue?vue&type=template&id=534fb251&"
import script from "./AfterScreening.vue?vue&type=script&lang=ts&"
export * from "./AfterScreening.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports